import { render, staticRenderFns } from "./TracklistVideoListInput.vue?vue&type=template&id=3b985c6a&"
import script from "./TracklistVideoListInput.vue?vue&type=script&lang=ts&"
export * from "./TracklistVideoListInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports